import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as vars from '../../constants/constants';
import { show, hide } from '../../actions/ActivityIndicatorActions';
import { checkAccess } from '../../actions/WelcomeActions';
import axios from 'axios';
import { config } from '../../constants/domainConfig';
import { Row, Col } from 'reactstrap';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import MsisdnNotFound from '../MsisdnNotFound';
import {sendData} from './../../analytics/sendData'

class twoStepLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
           username: '',
           password: '',
           isValid: false,
           errorMessage: ''
        };
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.isValid = this.isValid.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.callAuthenticate = this.callAuthenticate.bind(this);
    }

    isValid() {
        if (this.state.username == '') {
            this.setState({
                isValid: false,
                errorMessage: 'User Name is required'
            });
            return false;
        }
        if (this.state.password == '') {
            this.setState({
                isValid: false,
                errorMessage: 'Password is required'
            });
            return false;
        }
        return true;
    }

    onChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onKeyUp(e) {
        if (e.keyCode == 13) {
            if (this.isValid()) {
                this.setState({ isValid: true, errorMessage: '' });
                this.callAuthenticate({
                    username: this.state.username,
                    password: this.state.password
                });
                console.log(this.state)
            }
        }
    }

    onSubmit(e) {
        e.preventDefault();
        if (this.isValid()) {
            this.setState({ isValid: true, errorMessage: '' });
            this.callAuthenticate({
                username: this.state.username,
                password: this.state.password
            });
        }
    }

    callAuthenticate(data) {
        this.props.show();
        axios.post(vars.BASE_API_URL + `/checkAccessWithUsername`, {
            username: data.username,
            password: data.password,
        })
        .then((response) => {
            this.props.hide();
            if (response.data.success) {
                let data = {
                    success: response.data.success,
                    uid: response.data.data.payload.token,
                    token: response.data.data.token,
                    subscriptionData: response.data.data.payload,
                    rockmanId: response.data.data.payload.rockmanId
                };
                sessionStorage.setItem("authorized", JSON.stringify(data))
                this.props.checkAccess(data);
                sendData(data.rockmanId, '', '', 'Accessed', { method: 'username', status: 'success', url: window.location.href});
                let to = `/home?uid=${data.uid}`;
                this.props.history.push(to);
            }
            else{
                this.setState({
                    isValid: false,
                    errorMessage: response.data.data.payload.reason
                })
            }
        })
        .catch((error) => {
            this.props.hide();
            console.log(error);
            this.props.history.push("/login");
        });
    }

    render() {
            return (
                <div className="login animated fadeIn">
                    <Row className="justify-content-center">
                        <Col>
                            <Row className="login-page-header">
                                <div className="login-page-header-child">
                                    <img className={config.newDomain === 'fitness-bay' || config.newDomain == 'fun-box' ? 'login-page-logo-alt' : 'login-page-logo'} src={config.newDomain === 'telemovil' ? "./img/telemovil.png" : config.newDomain === 'trendme' ? "./img/trendme.png" : config.newDomain === 'fun-box' ? "./img/funbox.svg" : config.newDomain === 'mobioviewtv' ? "./img/MobioviewTV.svg" : config.newDomain === 'flamilingo' ? "./img/flamilingo.png" : config.newDomain === 'fitness-bay' ? "./img/fitness-bay.png" : config.subDomain.includes('mobiofit')? "./img/logo/mobiofitlogo.svg" : "./img/logo.png"} alt="MobioTV" />
                                </div>
                            </Row>
                                <Row className="login-page-content">
                                    <h1>
                                    <FormattedMessage id="pleaseLogin"
                                        defaultMessage="Devam etmek için lütfen giriş yapınız"
                                    />
                                    </h1>
                                    <p>
                                        <FormattedHTMLMessage id="loginUsing"
                                            defaultMessage="Mesajla gelen kullanıcı adını ve şifreyi kullanarak giriş yapın"
                                        />
                                    </p>

                                    <div className="login-page-mobile_num">

                                        <input autoFocus type="text" name="username" value={this.state.username} onChange={this.onChange} onKeyUp={this.onKeyUp} className="LoginRoute-number" 
                                            placeholder="Kullanıcı adı" 
                                        />

                                        <input type="password" name="password" value={this.state.password} onChange={this.onChange} onKeyUp={this.onKeyUp} className="LoginRoute-number" 
                                        placeholder="Şifre" 
                                        /> 

                                        <button type="submit" onClick={this.onSubmit} className={config.useMobiofitTheme ? 'LoginRoute-button LoginRoute-button-mobiofit':'LoginRoute-button'}>
                                            <FormattedMessage id="login"
                                                defaultMessage="giriş"
                                            />
                                            <i className="icon-back"></i>
                                        </button>
                                        {this.state.errorMessage.length > 0 ? <span className="error-message" style={{color: 'red', marginTop: '0.5rem'}}>
                                                                {this.state.errorMessage}
                                                            </span> : null
                                    }
                                    </div>
                                </Row>
                        </Col>
                    </Row>
                </div>
            );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.AuthenticationReducer,
        loader: state.ActivityIndicatorReducer,
        access: state.WelcomeReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        // authenticate,
        checkAccess,
        show,
        hide
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(twoStepLogin);



// WEBPACK FOOTER //
// ./src/components/Login/twoStepLogin.js